import request from '@/utils/request'


// 查询商家发货地址列表
export function listSendAddr(query) {
  return request({
    url: '/sendAddr/sendAddr/list',
    method: 'get',
    params: query
  })
}

// 查询商家发货地址分页
export function pageSendAddr(query) {
  return request({
    url: '/sendAddr/sendAddr/page',
    method: 'get',
    params: query
  })
}

// 查询商家发货地址详细
export function getSendAddr(data) {
  return request({
    url: '/sendAddr/sendAddr/detail',
    method: 'get',
    params: data
  })
}

// 新增商家发货地址
export function addSendAddr(data) {
  return request({
    url: '/sendAddr/sendAddr/add',
    method: 'post',
    data: data
  })
}

// 修改商家发货地址
export function updateSendAddr(data) {
  return request({
    url: '/sendAddr/sendAddr/edit',
    method: 'post',
    data: data
  })
}

// 删除商家发货地址
export function delSendAddr(data) {
  return request({
    url: '/sendAddr/sendAddr/delete',
    method: 'post',
    data: data
  })
}
